import React, { ElementType, FC } from 'react';
import classNames from 'classnames';

import classes from './styles/index.module.scss';

type HeadingSizes = 1 | 2 | 3 | 4 | 5 | 6;
type HeadingElement = ElementType<
	React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>
>;

type HeadingProps = {
	size?: HeadingSizes;
	dark?: boolean;
	light?: boolean;
	bold?: boolean;
	uppercase?: boolean;
	className?: string;
	dataTestId?: string;
};

export const Heading: FC<React.PropsWithChildren<HeadingProps>> = ({
	size = 4,
	className,
	light,
	dark = true,
	children,
	uppercase,
	bold = true,
	dataTestId,
}) => {
	const sizeTagMap: Record<HeadingSizes, HeadingElement> = {
		6: 'h6',
		5: 'h5',
		4: 'h4',
		3: 'h3',
		2: 'h2',
		1: 'h1',
	};

	const TagName = sizeTagMap[size];

	const headingClasses = classNames(classes.heading, className, {
		[classes.heading_6]: size === 6,
		[classes.heading_5]: size === 5,
		[classes.heading_4]: size === 4,
		[classes.heading_3]: size === 3,
		[classes.heading_2]: size === 2,
		[classes.heading_1]: size === 1,
		[classes.heading_light]: light,
		[classes.heading_dark]: dark,
		[classes.heading_uppercase]: uppercase,
		[classes.heading_bold]: bold,
	});

	return (
		<TagName
			className={headingClasses}
			data-testid={dataTestId}
		>
			{children}
		</TagName>
	);
};
